import React from 'react';
export const AccordionContext = React.createContext({
    panelsToOpenOnMount: [],
});
export const useAccordion = () => React.useContext(AccordionContext);
//# sourceMappingURL=AccordionContext.js.map